module.exports = __webpack_public_path__ + "img/inspector-perfectionist.ec93d476.svg";